import { render, staticRenderFns } from "./explore_duo_core_banner.vue?vue&type=template&id=413c2a1e&scoped=true"
import script from "./explore_duo_core_banner.vue?vue&type=script&lang=js"
export * from "./explore_duo_core_banner.vue?vue&type=script&lang=js"
import style0 from "./explore_duo_core_banner.vue?vue&type=style&index=0&id=413c2a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c2a1e",
  null
  
)

export default component.exports